import { getNinjaConfig } from '@/config/ninja';
import { getRegionConfig } from '@/config/region';
import { AVAILABLE_TRACKERS } from '@/generated/types.generated.ts';
import { getLogger } from '@/logger';
import { setDefaultGoogleConsents } from '@/utils/consent';

const logger = getLogger('initGa');

export function initGa(token: string, customDataLayer: string) {
  // Overwrite - OT has its own version of this function which uses the default dataLayer.
  // We need to make sure that the custom data layer is used for pushing events and consents.
  window.gtag = function gtag() {
    // oxlint-disable-next-line
    (window as any)[customDataLayer].push(arguments);
  };

  setDefaultGoogleConsents(customDataLayer);

  const crossDomains = getRegionConfig()?.custom?.[getNinjaConfig().siteUrl].config[AVAILABLE_TRACKERS.ga]?.cross_domains;
  if (crossDomains) {
    window.gtag('set', 'linker', { domains: crossDomains });
  }
  window.gtag('js', new Date());
  window.gtag('config', token, { anonymize_ip: true });

  logger.debug('GA tracker initialized');
}
